import React from 'react'
import signature from '../../assets/signature.png'
// import useOutsideClick from '../helpers/useOutsideClick'
import { BigStar } from '../helpers/Star'

const Certificate = ({ tweets, cert }) => {
  // console.log(tweets)
  // console.log(cert)
  return (
    <div className="certificate">
      <div className="certificate_star--container">
        <BigStar className="certificate_star" />
      </div>
      <h1 className="certificate_title">
        Certificate
        <br /> of <span>Adoption</span>
      </h1>
      <div className="certificate_info">
        <div className="certificate_info--adopter">
          <p>This certifies that the star {cert.star_name} has been adopted for</p>
          <h3>{tweets.user.display_name}</h3>
        </div>
        <p className="certificate_info--program">
          from the nonprofit Adopt a Star program to support the scientific research efforts of an International team of astronomers.
        </p>
      </div>
      <div className="starNo">
        <p>
          Adopted star: {cert.star_name}
          <br />
          <a href={cert.url} target="_blank" rel="noreferrer" className="external-link">
            {cert.url}
          </a>
        </p>
      </div>
      <div className="sig">
        <img className="signature" src={signature} alt="A signature" />
        <hr></hr>
        <p>White Dwarf Research Corporation</p>
      </div>
    </div>
  )
}

export default Certificate
